module.exports = "<div>{{ day }}</div>\r\n<span class=\"caption\">{{ (day + 100) * day }}$</span>\r\n"